export const config = {
  '7fs': {
    x: 0,
    y: 10,
    scale: 1,
  },
  '8fs': {
    x: 0,
    y: 10,
    scale: 1,
  },
  '9fs': {
    x: 0,
    y: 10,
    scale: 1,
  },
  '10fs': {
    x: 0,
    y: 10,
    scale: 1,
  },
}
